// ===================================================
// dateUtils.js — 날짜 관련 유틸 함수 모음
//
// 프로젝트 전체에서 날짜 형식을 일관되게 사용하기 위해
// 여기서 중앙 관리합니다.
// ===================================================

// 오늘 날짜를 "YYYY-MM-DD" 형식으로 반환
export function getToday() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
